export default __webpack_public_path__ + "static/media/movietime.be1ccfac.svg";